<template>
  <div class="row reporting-metrics">
    <div class="col-md-3" v-for="(metric, i) in metrics" :key="i">

      <stat :title="metric.label" :value="metric.value"></stat>

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import stat from "../../../../../components/widgets/stat";

export default {
  name: "ReportingMetrics",
  components: {
    'stat': stat
  },
  computed: {
    ...mapGetters('reportEditor', {
      metrics: 'metrics'
    })
  }
}
</script>

<style lang="scss">
.reporting-metrics {
  .card {
    background: #ebeff3;
  }
}
</style>